import type { RunsPageSummary } from "./runsSummaryTypes"

/**
 * Flatten the simulations-page summary into the markdown Sofia presents.
 *
 * The summary is assembled client-side as structured parts (a lead sentence
 * plus either grouped detail sections or a flat signal list) because the page
 * used to lay them out itself. Now that it is shown as prose — in the header
 * popover and as Sofia's opening message — those parts need one canonical
 * markdown rendering, so both surfaces read identically.
 */
export function buildRunsPageSummaryMarkdown(summary: RunsPageSummary): string {
  const blocks: string[] = []

  const lead = summary.summaryText.trim()
  if (lead) {
    blocks.push(lead)
  }

  if (summary.detailSections.length > 0) {
    for (const section of summary.detailSections) {
      if (section.items.length === 0) {
        continue
      }
      blocks.push(
        [
          `**${section.title}**`,
          ...section.items.map((item) => `- ${item}`),
        ].join("\n"),
      )
    }
  } else if (summary.signalItems.length > 0) {
    blocks.push(summary.signalItems.map((item) => `- ${item}`).join("\n"))
  }

  return blocks.join("\n\n")
}
